import {
  BorderProps,
  ButtonModalProps,
  ButtonProps,
  TextProps,
} from 'spindl-shared-components';
import { ModalRowListProps } from '../../molecules/ModalRowList';


type RowExpandedModalInternalProps = {
  tableName?: TextProps;
  closeButton?: ButtonProps;
  rowNumber?: TextProps;
  button?: ButtonProps;
  border?: BorderProps;
  modalRowList?: ModalRowListProps;
  deleteModal?: ButtonModalProps; // MANUAL OVERRIDE
};

type RowExpandedModalPropsValues = {
  '': RowExpandedModalInternalProps;
};

const propValues: RowExpandedModalPropsValues = {
  '': {
    deleteModal: { // MANUAL OVERRIDE
    },
    tableName: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Body4',
    },
    closeButton: {
      type: 'IconNoBG',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
    rowNumber: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body3',
    },
    button: {
      type: 'ComponentIcon',
      size: 'S',
      styleType: 'Destructive',
      state: 'Default',
    },
    border: {
      colour: 'SubduedLight',
      type: 'Horizontal',
      styleType: 'Default',
    },
    modalRowList: {
    },
  },
};

const getProps = (type: string): RowExpandedModalInternalProps => {
  const values: RowExpandedModalInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
